import { Divider, IconButton, ListItemText, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { type MouseEvent as ReactMouseEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import { useFetchEntity } from '../../io/useEntities'
import EntityWithLabelAndRelated from '../../domain/entity/EntityWithLabelAndRelated'
import EntityId = com.eidu.sharedlib.entity.EntityId

type ActionsMenuProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
}

const ActionsMenu = ({ userEntityId, signOut }: ActionsMenuProps) => {
  const navigate = useNavigate()
  const fetchEntity = useFetchEntity()

  const [userEntity, setUserEntity] = useState<EntityWithLabelAndRelated>()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  useEffect(() => {
    if (userEntityId)
      fetchEntity(userEntityId).then((entity) => {
        if (entity !== null) setUserEntity(entity)
      })
  }, [userEntityId, fetchEntity])

  const close = () => setAnchorEl(null)
  const open = (event: ReactMouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)

  const openCurrentUser = () => {
    if (!userEntity) return
    close()
    navigate(`/entities/${userEntity.entity.typeId.toString()}/view/${userEntity.entity.id.toString()}`)
  }

  if (!userEntity && !signOut) return null

  return (
    <>
      <IconButton edge="end" color="inherit" aria-label="Open user actions menu" onClick={open}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        {userEntity && (
          <MenuItem onClick={openCurrentUser}>
            <ListItemText
              primary="Your Profile"
              secondary={userEntity.primaryLabelText || userEntity.entity.id.toString()}
            />
          </MenuItem>
        )}
        {userEntity && signOut && <Divider />}
        {signOut && (
          <MenuItem
            onClick={() => {
              close()
              signOut()
            }}
          >
            Log out
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ActionsMenu
